<i18n lang="yaml" locale="en">
  autoplay: Autoplay
  delay time (seconds): Delay time (seconds)
  activate password: Activate password protection
  set password: Set password
  password: Password
  active: Active
  font (menu): Menu font
  add font long: Add a font by dropping it here.
  add font short: Add as font.
  enter password: Please enter the password.
  wrong password: Wrong password.
  unlocked: Unlocked successfully.
</i18n>

<i18n lang="yaml" locale="de">
  autoplay: Autoplay
  delay time (seconds): Verzögerung (Sekunden)
  activate password: Passwortschutz aktivieren
  set password: Passwort setzen
  password: Passwort
  active: Aktiv
  font (menu): Menü-Schriftart
  add font long: Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.
  add font short: Als Schriftart hinzufügen.
  enter password: Bitte geben Sie das Passwort an.
  wrong password: Falsches Passwort.
  unlocked: Erfolgreich entsperrt.
</i18n>

<script>
import Slider from '@/components/modules/Slider'
import Close from '@/components/icons/Close'
import { Prompt, Success, Error } from '@/plugins/snotify'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'idle',
  extends: BaseModule,
  customStore: translatable,
  props: {
    // eslint-disable-next-line
    _headlineAutoplay: {
      input: 'heading',
      label: 'autoplay'
    },
    slideChangeDelay: {
      type: Number,
      default: 10,
      input: 'number',
      label: 'delay time (seconds)',
      min: 1
    },
    // eslint-disable-next-line
    _headlineActivatePassword: {
      input: 'heading',
      label: 'activate password'
    },
    passwordActive: {
      label: 'active',
      input: 'checkbox',
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line
    _headlineSetPassword: {
      input: 'heading',
      label: 'set password'
    },
    password: {
      type: String,
      label: 'password',
      input: 'text',
      default: ''
    },
    // eslint-disable-next-line
    _headlineFont: {
      input: 'heading',
      label: 'font (menu)'
    },
    font: {
      input: 'drop',
      type: String,
      contentType: 'font',
      placeholder: 'add font long',
      tooltip: 'add font short',
      default: ''
    }
  },
  data () {
    return {
      promptActive: false
    }
  },
  methods: {
    clickHandler (event) {
      if (!this.$editMode) {
        event.stopPropagation()
        this.close()
      }
    },
    close () {
      const checkPassword = (password) => {
        if (password === this.password) {
          this.$router.replace('/')
          new Success(this.$t('unlocked'), 1000).open()
          this.promptActive = false
        } else {
          new Error(this.$t('wrong password')).open()
          this.promptActive = false
        }
      }
      if (this.passwordActive) {
        if (!this.promptActive) {
          this.promptActive = true
          new Prompt(this.$t('password'), this.$t('enter password'), checkPassword, undefined, () => { this.promptActive = false }).open()
        }
      } else {
        this.$router.replace('/')
      }
    }
  },
  watch: {
    'isAppIdle' (newValue) {
      if (!this.$editMode && newValue) {
        this.$router.replace(this.$store.getters.path)
      }
    }
  },
  render (createElement) {
    return createElement('transition', { props: { name: 'bounce' } }, [
      createElement('div', { class: { idle: true, active: this.isActive } }, [
        createElement('keep-alive', [
          this.isActive && createElement(Slider, {
            props: {
              setComponentRef: false,
              path: this.path,
              autoplay: true,
              slideChangeDelay: this.slideChangeDelay,
              menuActive: this.$editMode,
              font: this.font
            },
            attrs: this.$attrs,
            nativeOn: {
              '!click': this.clickHandler
            }
          }, this.children.map((child) => {
            return createElement(child.getters.type, {
              key: child.getters.path,
              props: {
                path: child.getters.path,
                ...child.getters.props
              }
            })
          }))
        ]),
        this.$editMode && this.isActive && createElement('div', { class: 'close', on: { click: this.close } }, [
          createElement(Close, { props: { color: 'secondary', size: 'xs' } })
        ])
      ])
    ])
  }
}
</script>

<style lang="scss" scoped>
.idle {
  display: none;
  &.active {
    display: initial;
  }

  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  .close {
    position: absolute;
    top: 3%;
    right: 2%;
    background-color: #000;
    line-height: 0;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #fff;
    cursor: pointer;
    transform: translateX(40%) translateY(-40%);
  }
}
</style>
